module.exports = __webpack_public_path__ + "static/media/ecran.1fe4ec66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ecran.jpg
// module id = 350
// module chunks = 0